import { render, staticRenderFns } from "./ForrajesDeVeterinaria.vue?vue&type=template&id=99202ed0&scoped=true&"
import script from "./ForrajesDeVeterinaria.vue?vue&type=script&lang=js&"
export * from "./ForrajesDeVeterinaria.vue?vue&type=script&lang=js&"
import style0 from "./ForrajesDeVeterinaria.vue?vue&type=style&index=0&id=99202ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99202ed0",
  null
  
)

export default component.exports